import api from '../../api'
import _ from 'lodash'

const defaultState = () => ({
  purchasedData: [],
  allPurchasedData: [],
  teamsData: []
})

export default {
  defaultState,
  state: defaultState,
  getters: {
    myTeamPurchasedData: state => state.purchasedData,
    allPurchasedData: state => state.allPurchasedData,
    teamsData: state => state.teamsData
  },
  actions: {
    async fetchPurchasedData({ commit, getters }) {
      const team = getters.myTeam
      try {
        const { data } = await api.data.findAllByTeamId(team.id)
        commit('SET_DATA', data)
      }
      catch (e) {
        //this.$toast.error('Something went wrong!');
      }
    },
    async fetchAllPurchasedData({ commit, getters }) {
      const id = getters.currentGameId;

      if (id) {
        try {
          const { data } = await api.data.findAllDataBought(id)
          const groupedTypes = _.groupBy([...data], item => item.type)
          const allTypesData = []
          _.forOwn(groupedTypes, dataRows => {
            //musí to být, aby se data přiřazovala správným týmům
            let sorted = dataRows.sort((a, b) => {if (a.teamId > b.teamId) {return 1} else if (a.teamId === b.teamId) {return 0} else return -1});
            if (sorted[0]) {
              allTypesData.push({
                id: sorted[0].id,
                name: sorted[0].type,
                results: sorted,
              })
            }
          });
          commit('SET_ALL_DATA', allTypesData)

          const groupedTeams = _.groupBy([...data], item => item.teamId)
          const allTeamsData = [];
          _.forOwn(groupedTeams, dataRows => {
            if (dataRows[0]) {
              allTeamsData.push({
                id: dataRows[0].teamId,
                name: getters.gameAllTeams.find(team => team.id === dataRows[0].teamId).name,
                results: dataRows,
              })
            }
          });
          commit('SET_TEAMS_DATA', allTeamsData)
        } catch (e) {
          this.$toast.error('Something went wrong!');
        }
      }
    },
    async downloadPurchasedData({ commit }, id) {
      try {
        const answer = await api.data.download(id)
        const url = window.URL.createObjectURL(new Blob([answer.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', answer.headers['content-disposition'].split('filename=')[1].replaceAll('"', ''));
        document.body.appendChild(link);
        link.click();
      }
      catch (e) {
        this.$toast.error('Something went wrong!');
      }
    },
    async purchaseData({ dispatch }, dataProduct) {
      if (dataProduct.type) {
        try {
          const { data } = await api.data.purchase(dataProduct.type)
          await dispatch('downloadPurchasedData', data.id);
          this.$toast.success(`${dataProduct.title} purchased!`)
        }
        catch (e) {
          this.showError(e)
        }
      }
    },
    SOCKET_TEAM_DATA({ dispatch, commit }, data) {
      commit('ADD_DATA', data)
      dispatch('addTeamMoney', -data.price)
    }
  },
  mutations: {
    SET_DATA(state, data) {
      state.purchasedData = data || []
    },
    SET_ALL_DATA(state, data) {
      state.allPurchasedData = data || []
    },
    SET_TEAMS_DATA(state, data) {
      state.teamsData = data || []
    },
    ADD_DATA(state, data) {
      state.purchasedData.push(data)
    }
  }
}
